import setFaq from './pages/faq';
import setTabsTermos from './pages/setTerms';
import addVideos from './pages/addVideos';
//addImports

const Page = {
  init: function () {
    var _this = this;
    addVideos();
    setFaq();
    setTabsTermos();
    //calls
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Page.init();
});
